import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import ButtonComponent from '../button-component.js';
import { ButtonViewer } from '../viewer/button-viewer.js';
import '../classNameStrategies.js';
import 'classnames';
import 'lodash';
import '../default-styles-74c82233.js';
import './button-viewer.js';
import '../types.js';
import 'ricos-context';

var css_248z = ".Q6sfD{height:104px;width:100%}[dir] .Q6sfD{background:#f2f2f2}.VM19r{color:#d3d3d3;font-size:10px;width:100%}[dir] .VM19r{padding-top:10px;text-align:center}[dir] .iV7-z{padding-bottom:14px;padding-top:6px;text-align:center}";
var styles = {"button_PreviewComponent_preview_container":"Q6sfD","button_PreviewComponent_header":"VM19r","button_PreviewComponent_button":"iV7-z"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class PreviewComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    var _a;
    const { t, experiments } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: this.styles.button_PreviewComponent_preview_container }, /* @__PURE__ */ React.createElement("div", { className: this.styles.button_PreviewComponent_header }, t("ButtonModal_Preview_Label")), /* @__PURE__ */ React.createElement("div", { className: this.styles.button_PreviewComponent_button }, ((_a = experiments.tiptapEditor) == null ? void 0 : _a.enabled) ? /* @__PURE__ */ React.createElement(ButtonViewer, __spreadValues({}, this.props)) : /* @__PURE__ */ React.createElement(
      ButtonComponent,
      __spreadValues({
        theme: this.props.theme,
        style: { pointerEvents: "none" }
      }, this.props)
    )));
  }
}
PreviewComponent.propTypes = {
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  experiments: PropTypes.object
};

export { PreviewComponent as default };
//# sourceMappingURL=preview-component.js.map
